import Swiper from 'swiper'

const swiperThumbs = document.querySelector('.swiper-container-thumbs')
const isHome = !!document.querySelector('.home-slider')
const fadeOptions = isHome
  ? {
      autoplay: true,
      speed: 600,
      effect: 'fade',
      loop: true,
    }
  : {
      loop: false,
    }

let mySwiperThumbs = {}
let componentCarousel = {}

if (swiperThumbs) {
  mySwiperThumbs = new Swiper('.swiper-container-thumbs', {
    slidesPerView: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    spaceBetween: 0,
  })
}

if (swiperThumbs) {
  componentCarousel = new Swiper('.swiper-container', {
    thumbs: {
      swiper: mySwiperThumbs || null,
    },
    ...fadeOptions,
  })
} else {
  componentCarousel = new Swiper('.swiper-container', {
    ...fadeOptions,
  })
}
